import { useState, useEffect } from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';

const reviews = [
  {
    name: 'Colleen T.',
    rating: 5,
    text: 'Simply the best! Willie was extremely accommodating and ensured our safe and reliable transport around Charleston this past week. I would highly recommend his services to anyone looking to explore the Charleston area, or simply travel in comfort to and from the airport. His professionalism is top notch, and it\'s evident he takes pride in delivering the best possible service to each and every one of his clients!',
  },
  {
    name: 'Jay A.',
    rating: 5,
    text: 'Outstanding and friendly service. Excellent communication beforehand so that you know Mr. Robinson will be there to pick you up at the scheduled time. Not only on time, but EARLY! On the way to the airport, Mr. Robinson kindly drove my daughter and me to some of the local points of interest tourists don\'t usually see. We will definitely rely on Mr. Robinson\'s services again in the future. I HIGHLY RECOMMEND Willie Robinson for your professional driver needs.',
  },
  {
    name: 'Betsy G.',
    rating: 5,
    text: 'Willie was amazing! He took our family around for the entire day. We went to the local winery and breweries then ended in downtown Charleston for a fabulous dinner! He was like part of the family — laughs, great conversation, and safe travels. We highly recommend using TECS for all your transportation needs! We look forward to our next trip. Thanks Willie!',
  },
  {
    name: 'Cody C.',
    rating: 5,
    text: 'Willie was the best limo service we have experienced, hands down. Very friendly, attentive, and always made sure to be early — not just "on time." Reasonably priced and exceptional service. 10/10. Would not hesitate to use again for any occasion.',
  },
  {
    name: 'Chanel L.',
    rating: 5,
    text: 'Willie was a true pleasure! He picked me up from downtown Charleston last week to take me to the airport. He was prompt, friendly, and fun to talk with. A completely stress-free experience from start to finish. Highly recommend!',
  },
];

export default function PageTestimonials() {
  const [current, setCurrent] = useState(0);
  const ref = useScrollReveal<HTMLDivElement>();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((c) => (c + 1) % reviews.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  const prev = () => setCurrent((c) => (c - 1 + reviews.length) % reviews.length);
  const next = () => setCurrent((c) => (c + 1) % reviews.length);

  return (
    <section className="relative py-28 overflow-hidden" style={{ backgroundColor: '#0a0a0a' }}>
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/255e17a775ac0ead957d61a90b88e320.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>
      <div className="absolute inset-0 bg-[#0a0a0a]/92"></div>

      <div className="max-w-5xl mx-auto px-6 relative">
        <div ref={ref} className="section-reveal text-center mb-14">
          <span className="text-gold text-xs tracking-widest uppercase font-semibold">Client Reviews</span>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white mt-3">
            What Clients Are Saying
          </h2>
          <div className="flex items-center justify-center gap-1 mt-5">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-gold text-base"></i>
              </div>
            ))}
            <span className="text-white/40 text-xs ml-2">5.0 · Google Verified Reviews</span>
          </div>
        </div>

        <div className="relative">
          <div className="border border-gold/15 bg-neutral-900/80 backdrop-blur-sm p-10 md:p-14 text-center min-h-[280px] flex flex-col justify-center">
            <div className="w-10 h-10 flex items-center justify-center mx-auto mb-6">
              <i className="ri-double-quotes-l text-gold/40 text-4xl"></i>
            </div>
            <p className="text-white/80 text-base md:text-lg leading-relaxed italic mb-8 transition-all duration-500 max-w-3xl mx-auto">
              &quot;{reviews[current].text}&quot;
            </p>
            <div className="flex items-center justify-center gap-4">
              <div className="flex gap-0.5">
                {[...Array(reviews[current].rating)].map((_, i) => (
                  <div key={i} className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-gold text-xs"></i>
                  </div>
                ))}
              </div>
              <span className="text-gold font-semibold text-sm tracking-widest">— {reviews[current].name}</span>
            </div>
          </div>

          <div className="flex items-center justify-between mt-6">
            <button onClick={prev} className="w-11 h-11 border border-gold/25 hover:border-gold hover:bg-gold/10 flex items-center justify-center transition-all cursor-pointer" aria-label="Previous">
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-left-line text-gold text-sm"></i></div>
            </button>
            <div className="flex gap-2">
              {reviews.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrent(i)}
                  className={`transition-all duration-300 cursor-pointer ${i === current ? 'w-8 h-2 bg-gold' : 'w-2 h-2 bg-white/15 hover:bg-white/35'}`}
                  aria-label={`Review ${i + 1}`}
                />
              ))}
            </div>
            <button onClick={next} className="w-11 h-11 border border-gold/25 hover:border-gold hover:bg-gold/10 flex items-center justify-center transition-all cursor-pointer" aria-label="Next">
              <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-gold text-sm"></i></div>
            </button>
          </div>
        </div>

        <div className="text-center mt-10">
          <a
            href="https://goo.gl/maps/jrKSzYSzTT1bAbWc7"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-flex items-center gap-2 border border-gold/35 text-gold hover:bg-gold hover:text-black transition-all px-8 py-3 text-xs tracking-widest uppercase cursor-pointer whitespace-nowrap font-bold"
          >
            <div className="w-4 h-4 flex items-center justify-center"><i className="ri-star-fill text-sm"></i></div>
            Leave Us a Review on Google
          </a>
        </div>
      </div>
    </section>
  );
}
